module.exports = __webpack_public_path__ + "media/images/questions-ff3e305186bef536183b77c10ce8aa10.png";